import { render, staticRenderFns } from "./about-us-location.vue?vue&type=template&id=2bbf35c6&scoped=true&"
import script from "./about-us-location.vue?vue&type=script&lang=js&"
export * from "./about-us-location.vue?vue&type=script&lang=js&"
import style0 from "./about-us-location.vue?vue&type=style&index=0&id=2bbf35c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf35c6",
  null
  
)

export default component.exports